import { getAuthMeta } from './auth'

// 按账号、环境和盒码隔离，页面跳转/刷新后仍可恢复原始取件码。
export function kitBindContext (query, pid, storage) {
  const auth = getAuthMeta()
  const owner = auth.userId || auth.externalUserId || ''
  const code = String(pid || query.pid || '').trim()
  if (!owner || !code) return {}
  const entryPid = String(query.pid || query.code || query.checkId || '').trim()
  if (entryPid && entryPid !== code) return {}
  const key = 'wpc_kit_bind:' + JSON.stringify([owner, query.envKey || auth.envKey || '', code])
  try { storage = storage || window.sessionStorage } catch (error) {}
  if (Object.prototype.hasOwnProperty.call(query, 'state')) {
    const state = String(query.state == null ? '' : query.state)
    try {
      if (state) storage.setItem(key, state)
      else storage.removeItem(key)
    } catch (error) {}
    return state ? { pid: code, state } : {}
  }
  try {
    const state = storage.getItem(key)
    return state ? { pid: code, state } : {}
  } catch (error) { return {} }
}



// WEBPACK FOOTER //
// ./src/utils/kitBindContext.js